( function ( _s ) {
	const playPauseVideo = ( type, iframe, status ) => {
		if ( iframe.contentWindow ) {
			// Pause Youtube Videos
			if ( iframe.src.startsWith( 'https://www.youtube.com' ) ) {
				iframe.contentWindow.postMessage(
					'{"event":"command","func":"' +
						( status === 'play' ? 'playVideo' : 'pauseVideo' ) +
						'","args":""}',
					'*'
				);
			}
			// Pause Vimeo Videos
			if ( iframe.src.startsWith( 'https://player.vimeo.com/' ) ) {
				iframe.contentWindow.postMessage(
					'{"method":"' + ( status === 'play' ? 'play' : 'pause' ) + '"}',
					'*'
				);
			}
		}
	};

	_s.fn.videoPlayPauseOnIntersection = function () {
		return this.each( el => {
			const _self = _s( el );
			const type = el.nodeName.toLowerCase();

			if ( [ 'iframe', 'video' ].includes( type ) ) {
				new IntersectionObserver( entries => {
					entries.forEach( entry => {
						switch ( type ) {
							case 'iframe':
								playPauseVideo(
									type,
									_self.el[ 0 ],
									entry.isIntersecting ? 'play' : 'pause'
								);
								break;
							case 'video':
								if ( entry.isIntersecting ) {
									_self.el[ 0 ].play();
								} else {
									_self.el[ 0 ].pause();
								}
								break;
							default:
								break;
						}
					} );
				} ).observe( _self.el[ 0 ] );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '.video-intersection-listener' ).videoPlayPauseOnIntersection();
	} );
} )( window._s );
